<template>
    <Alert class="CriteriaWarningMessage" rounded>
        <EidIcon
            class="CriteriaWarningMessage__icon"
            :icon-src="icon"
            :svg-props="{color: alertWarningColor}"
            alt="icon"
        />
        <slot />
    </Alert>
</template>

<script lang="ts">
    import { Component, Vue } from '@evidentid/vue-property-decorator';

    import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

    import Alert from '@evidentid/dashboard-commons/components/Alert/Alert.vue';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import { tailwindColors } from '@/styles/variables/tailwind-colors/tailwindColors';

    @Component({
        components: {
            Alert,
            EidIcon,
        },
    })
    export default class CriteriaWarningMessage extends Vue {
        private icon = faExclamationTriangle;
        private alertWarningColor = tailwindColors.eidWarningYellow.DEFAULT;
    }
</script>
